export default __webpack_public_path__ + "static/media/sticker-K.f4d7c757.png";